

















































































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import {
  AccountSubscriptionOrder, Allocation,
  CommercialAccount, ConsolidatedSubscriptionOrder,
  Organisation,
  SubscriptionOrder,
  SubscriptionProduct,
} from '@/types';
import moment from 'moment';
import SubscriptionsService from '@/services/subscriptions.service';
import AccountSelect from '@/components/AccountSelect.vue';
import AccountService from '@/services/account.service';
import GenericButton from '@/components/GenericButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import SubscriptionOrderOrganisations from '@/components/subscriptions/SubscriptionOrderOrganisations.vue';
import AccountOrganisationAccess from '@/views/accounts/AccountOrganisationAccess.vue';
import {Getter} from 'vuex-class';
import {RouterHelper} from '@/router';

@Component({
  components: {
    AccountOrganisationAccess,
    SubscriptionOrderOrganisations, ConfirmButton, CancelButton, GenericButton, AccountSelect, Dialog},
})
export default class MultiOrgSubscriptionOrder extends Vue {
  @Getter private hasPermission!: any;
  @Getter private activeAccountId!: any;
  @Prop() private open!: boolean;
  @Prop() private orderToEdit!: ConsolidatedSubscriptionOrder;
  @Prop() private editing!: boolean;
  @Prop() private products!: SubscriptionProduct[];
  @Prop() private accounts!: CommercialAccount[];
  private defaultOrder: ConsolidatedSubscriptionOrder = { orderNumber: '' } as ConsolidatedSubscriptionOrder;
  private order: ConsolidatedSubscriptionOrder = this.defaultOrder;
  private activateBy: string | null = null;
  private dirty: boolean = false;
  private saving: boolean = false;
  private activateByMenu: boolean = false;
  private showOrganisations: boolean = false;
  private orgHeaders = [ { text: 'Organisation', value: 'organisationName' }, { text: 'Maximum subscriptions', value: 'allocatedSubscriptions' } ];
  private loading: boolean = false;
  private valid: boolean = false;
  private overallAllocationError: string = '';
  private accountRules = [(v: any) => !!v || 'Account is required'];
  private totalSubscriptionsRules = [(v: any) => v >= 0 || 'Total subscriptions is required'];
  private subscriptionProductRules = [(v: any) => !!v || 'Subscription product is required'];
  private spotPriceRules = [(v: any) => v >= 0 || 'Spot price is required'];
  private currencyRules = [(v: any) => !!v || 'Currency is required'];
  private currencyOptions = [{text: 'GBP'}, {text: 'USD'}, {text: 'EUR'}];

  private allocationsToAdd: any = [];
  private allocationsToKeep: any = [];

  @Watch('order.totalSubscriptions')
  private onTotalChange() {
    this.validateAllocations();
  }

  @Watch('orderToEdit', {immediate: true})
  private onOrderEdit() {
    if (!this.orderToEdit) {
      this.order = this.defaultOrder;
      return;
    }
    this.order = this.orderToEdit;

    if (this.order && (!this.order.account || (this.order.allocations && !this.order.allocations.length))) {
      const org = this.order.organisation;
      if (org) {
        this.order.allocations = [{
          organisationName: org.name,
          organisationId: org.id,
          allocatedSubscriptions: this.order.totalSubscriptions,
        }];
      } else {
        this.order.allocations = [];
      }
    }
  }

  private async mounted() {
    this.loading = true;
    try {
      if (this.order && this.order.allocations) {
        this.order.allocations.forEach((org) => {
          const consumed = Number(org.consumedSubscriptions) || 0;
          if (Number(org.allocatedSubscriptions) < consumed) {
            org.allocatedSubscriptions = consumed;
          }
        });
      }
      this.activateBy = moment(this.order.activateBy).format('YYYY-MM-DD');
    } finally {
      this.loading = false;
    }
  }

  private validateAllocations() {
    this.overallAllocationError = '';
    let totalAllocated = 0;

    if (!this.order.allocations) {
      totalAllocated += 0;
    } else {
      for (const org of this.order.allocations) {
        const allocated = Number(org.allocatedSubscriptions);
        const consumed = Number(org.consumedSubscriptions);
        totalAllocated += allocated;
        if (allocated < consumed) {
          this.overallAllocationError = `Allocations must be greater than or equal to activated quantity.`;
        }
        if (allocated === 0) {
          this.overallAllocationError = `Assign a minimum of 1 subscription. Remove organisations with 0 assigned to proceed.`;
        }
      }
    }

    if (!this.allocationsToAdd) {
      totalAllocated += 0;
    } else {
      for (const org of this.allocationsToAdd) {
        const allocated = Number(org.allocatedSubscriptions);
        totalAllocated += allocated;

        if (allocated === 0) {
          this.overallAllocationError = `Assign a minimum of 1 subscription. Remove organisations with 0 allocated to proceed.`;
        }
      }

    }

    if (totalAllocated > this.order.totalSubscriptions) {
      this.overallAllocationError = `The number of allocated subscriptions exceeds the order total of ${this.order.totalSubscriptions}.`;
    }
  }

  private async save() {
    this.saving = true;
    try {

      this.allocationsToKeep = [...this.allocationsToAdd, ...(this.order && this.order.allocations ? this.order.allocations : [])];

      const orgData = (this.allocationsToKeep || []).map((o: Allocation) => ({
        organisation_id: o.organisationId,
        quantity: Number(o.allocatedSubscriptions),
      })).filter((o: { quantity: number }) => o.quantity > 0);

      const payload = {
        ...this.order,

        subscription_product_id: this.order.subscriptionProduct ? this.order.subscriptionProduct.id : undefined,
        total_subscriptions: Number(this.order.totalSubscriptions),
        order_number: this.order.orderNumber || `DAIZY_${moment().format('YYYYMMDD_HHmmss')}`,
        activate_by: new Date(this.activateBy!),
        spot_price: this.order.spotPrice,
        quote_id: this.order.quoteId,
        commercial_account_id: this.order.account ? this.order.account.id : null,
        allocated_subscriptions: orgData,
      };


      if (this.order.account) {
        if (this.order.id) {
          if (this.hasPermission('administration:manage') && RouterHelper.isSubscriptions()) {
            await SubscriptionsService.updateOrganisationsSubscriptionOrder(this.order.id, payload);
          } else {
            await AccountService.updateAccountSubscriptionOrder(this.activeAccountId, this.order.id, payload);
          }
        } else {
          await SubscriptionsService.createOrganisationsSubscriptionOrder(payload);
        }
      }

      this.$emit('saved');
    } catch (e) {
      this.$emit('incompleteSubscriptionCreation');
      throw e;
    } finally {
      this.saving = false;
      this.$emit('close');
    }
  }

  private distribute() {
    if (!this.order.totalSubscriptions) {
      return;
    }
    if (!this.order.isManyToMany && this.order.allocations) {
      this.order.allocations[0].allocatedSubscriptions = this.order.totalSubscriptions;
      return;
    }
  }

  private setActivateBy() {
    if (this.order.subscriptionProduct) {
      this.activateBy = moment().add(this.order.subscriptionProduct.activation_period, 'days').format('YYYY-MM-DD');
    }
  }

  private filterProducts(item: SubscriptionProduct, queryText: string, itemText: string) {
    return (
        item.product_code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
    );
  }

  private get isDisabled() {
    return !!this.order.id && (RouterHelper.isAccounts() && !this.hasPermission('administration:manage')) || this.loading;
  }

  private get activateByLabel() {
    if (this.$options.filters) {
      return this.$options.filters.formatShortDate(this.activateBy);
    } else {
      return '';
    }
  }

  private get sortedAccounts() {
    const sortByName = (a: { id: number, name: string }, b: { id: number, name: string }) => {
      return a.name.localeCompare(b.name);
    };
    return this.accounts.slice().sort(sortByName);

  }

  private get tomorrow() {
    return moment().add(1, 'd').format('YYYY-MM-DD');
  }
  private get totalAllocatedSubscriptions(): number {
    let totalAllocated = 0;
    if (this.order && this.order.allocations) {
      for (const org of this.order.allocations) {
        totalAllocated += Number(org.allocatedSubscriptions) || 0;
      }
    }
    if (this.allocationsToAdd) {
      for (const org of this.allocationsToAdd) {
        totalAllocated += Number(org.allocatedSubscriptions) || 0;
      }
    }
    return totalAllocated;
  }

  private get totalConsumedSubscriptions(): number {
    let totalConsumed = 0;
    if (this.order && this.order.allocations) {
      for (const org of this.order.allocations) {
        totalConsumed += Number(org.consumedSubscriptions) || 0;
      }
    }
    return totalConsumed;
  }

  private get unallocatedSubscriptions(): number {
    return Number(this.order.totalSubscriptions) - this.totalAllocatedSubscriptions;

  }

  private get isFormValid() {
    return (!!(this.isOrganisationSelected || this.isAccountSelected) && this.isSubscriptionProductSelected && this.isSpotPriceSelected && this.isCurrencySelected && !this.overallAllocationError);
  }

  private get showAccountSelection() {
    return (this.order.account || !this.editing) && !this.isAccounts;
  }

  private get organisationFieldValue() {
    return `(No Account) ${this.order.organisation && this.order.organisation.name || ''}`;
  }

  private get isOrganisationSelected() {
    return this.order.organisation && this.order.organisation.id;
  }

  private get isAccountSelected() {
    return this.order.account && this.order.account.id;
  }

  private get isAccounts() {
    return RouterHelper.isAccounts();
  }

  private get isSubscriptionProductSelected() {
    return !!this.order.subscriptionProduct;
  }

  private get isSpotPriceSelected() {
    return !!this.order.spotPrice;
  }

  private get isCurrencySelected() {
    return !!this.order.currency;
  }

  private get showAllocationSection() {
    return (!!((this.order.account && this.order.account.id) || !!this.order.account) || !!this.order.organisation) && !!Number(this.order.totalSubscriptions);
  }
}
